import React, { useState, useRef, useEffect } from "react";
import { Palette, Check } from "lucide-react";
import { useTheme } from "../theme/ThemeProvider";
import { ACCENT_THEMES } from "../theme/themes";

export const ThemePicker = () => {
  const { theme, setTheme } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="theme-picker-button"
        aria-label="Choose accent theme"
        aria-expanded={open}
        className="relative w-9 h-9 flex items-center justify-center rounded-full border border-border-dim text-text-muted hover:text-theme-primary hover:border-theme-primary/50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-theme-primary"
      >
        <Palette className="w-4 h-4" />
      </button>
      {open && (
        <div
          data-testid="theme-picker-menu"
          className="absolute right-0 mt-2 w-52 p-2 rounded-xl border border-border-dim bg-surface shadow-2xl z-[60] animate-in fade-in slide-in-from-top-2 duration-150"
        >
          <p className="px-3 py-1.5 text-[10px] font-bold uppercase tracking-widest text-text-muted">Accent Theme</p>
          {ACCENT_THEMES.map((t) => (
            <button
              key={t.id}
              data-testid={`theme-option-${t.id}`}
              onClick={() => { setTheme(t.id); setOpen(false); }}
              className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-elevated transition-colors text-left"
            >
              <span
                className="w-6 h-6 rounded-full border border-border-dim shrink-0"
                style={{ background: `linear-gradient(135deg, ${t.swatch}, ${t.swatch2})` }}
              />
              <span className="text-sm text-text-main flex-1">{t.name}</span>
              {theme === t.id && <Check className="w-4 h-4 text-theme-primary" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
